import styled from 'styled-components';

import { sizeUp } from '~/theme';
import PlainCard from '~atoms/PlainCard';

export const Container = styled(PlainCard)({
  minInlineSize: sizeUp('245rem', ['xl', '300rem']),
  maxInlineSize: sizeUp('315rem', ['xl', '370rem']),
  padding: sizeUp('8.13rem', ['xl', '10rem']),
});

export const Img = styled.img({
  inlineSize: '100%',
  blockSize: sizeUp('160rem', ['xl', '200rem']),
  borderRadius: '5rem',

  objectFit: 'cover',
});

export const Name = styled.header(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',

  marginBlockStart: sizeUp('4rem', ['xl', '10rem']),

  fontFamily: theme.typography.family.playfairDisplay,
  fontSize: theme.typography.size20,
  lineHeight: '27rem',
  textTransform: 'uppercase',
}));

export const Price = styled.span(({ theme }) => ({
  fontFamily: theme.typography.family.arial,
  fontSize: sizeUp(theme.typography.size11, ['xl', theme.typography.size14]),
}));

export const Material = styled.p(({ theme }) => ({
  margin: 0,
  marginBlockStart: sizeUp('5rem', ['xl', '10rem']),

  fontSize: theme.typography.size14,
  fontFamily: theme.typography.family.arial,
}));
